import {
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';

import { commonIconList } from './common-icon-list.model';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { SdLibConfig } from '../../../sd-lib-config';

/**
 * Needs to have svg registry instanciated on the page to display icons
 */
@Component({
  selector: 'sd-icon',
  templateUrl: './icon.component.html',
  standalone: true,
  imports: []
})
export class SdIconComponent implements OnInit {
  constructor(private readonly sdLibConfig: SdLibConfig) {}

  _size: IconSizeEnum = IconSizeEnum.default;
  urlIcons = '/assets/icons/';
  configBrand: BrandsEnum = BrandsEnum.moulinex;

  @Input()
  brand: BrandsEnum;

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input()
  hasBorder = false;

  @Input()
  get size() {
    return this._size;
  }

  set size(size: IconSizeEnum) {
    if (!size) {
      throw new Error(
        `La taille que vous passez est ${size} pensez à utilisez [size]="'logo'",[size]="'large'", [size]="'small'" \n
        voir les types ${JSON.stringify(Object.keys(IconSizeEnum))}
      `,
      );
    }
    this._size = size;
  }

  @Input() class = 'c--icon'; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.size ? 'is-' + this.size : '',
      this.hasBorder ? 'has-border' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  ngOnInit() {
    this.configBrand = this.sdLibConfig.currentBrand;
  }

  checkIsCommon(iconName) {
    return commonIconList?.includes(iconName);
  }
}
